<template>
  <v-dialog v-model="ld_dialog" hide-overlay persistent width="300">
    <v-card :color="ld_color" dark>
      <v-card-text>
        {{ ld_text }}
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "loadingDialog",
  props: {
    ld_dialog: {
      type: Boolean,
      default: false,
    },
    ld_text: {
      type: String,
      default: "Please Wait",
    },
    ld_color: {
      type: String,
      default: "rgb(51, 97, 137)",
    },
  },
};
</script>

<style></style>
